
import { defineComponent, onBeforeMount, ref } from 'vue';
import { invokegetSkillProf, invokeGetProxyList, invokeAssignProxyToLearners } from '@/utils/admin/assign_proxy_service';
import { getAllProxyAssignedLearner, invokeAssignedProxyTriggerReport } from '@/utils/admin/view_proxy_request_service';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import moment from 'moment';
// eslint-disable-next-line
// import router from '@/router';
// import { XIcon } from 'vue-feather-icons';

export default defineComponent({
  name: 'AssignProxy',
  setup() {
    const learnerData = ref();
    const skills = ref();
    const proficiency = ref();
    const renderReady = ref();
    const selectedSkill = ref();
    const selectedProficiency = ref();
    const isVisible = ref(false);
    const proxyButtonVisible = ref(false);
    const proxyList = ref();
    const selectedTaskId = ref([]);
    const selectedProxyOhr = ref();
    const proxyAssignedBtn = ref(false);
    const userRole = ref();
    const showScreen = ref(true);
    const selectedLearnerSkill = ref();
    const selectedLearnerProficiency = ref();
    const reportSuccessMessage = ref();
    const checkOne = () => {
      selectedProxyOhr.value = [];
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setProxyBtn = (event: any) => {
      selectedTaskId.value = [];
      const cb = event.target.checked;
      if (cb === true) {
        proxyButtonVisible.value = true;
        // console.log(cb);
      } else {
        proxyButtonVisible.value = false;
        isVisible.value = false;
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const FilterData: any = {};
    const getSkillandProf = async () => {
      renderReady.value = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const dataRes: any = await invokegetSkillProf('/getAllSkillProf?skill_type=genome');
      skills.value = dataRes.skill;
      proficiency.value = dataRes.proficiency;
      renderReady.value = true;
    };
    const getLearnerForProxy = async () => {
      try {
        // if (FilterData.skill && FilterData.proficiency) {
        console.log(FilterData);
        renderReady.value = false;
        await checkOne();
        selectedTaskId.value = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const dataRes: any = await getAllProxyAssignedLearner(FilterData);
        learnerData.value = dataRes.data.allProxyList;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // learnerData.value = learnerData.value.sort((a: any, b: any) => moment(a.assignment_date).utc().unix() - moment(b.assignment_date).utc().unix());
        for (let index = 0; index < learnerData.value.length; index += 1) {
          const res = learnerData.value[index];
          console.log(`res ${JSON.stringify(res)}`);
          const today = moment().utc().format('YYYY-MM-DD');
          if (res.assignment_date) {
            const assignDateFormatted = moment(res.assignment_date).utc().format('YYYY-MM-DD');
            res.ageing = moment(today).diff(moment(assignDateFormatted), 'days');
            res.assignment_date = moment(res.assignment_date).format('DD-MM-YYYY');
          }
          if (res.proxy_requested_date) {
            res.proxy_requested_date = moment(res.proxy_requested_date).format('DD-MM-YYYY');
          }
          if (res.skill) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const learnerSkillArr = skills.value.filter((item: any) => {
              console.log(`item ${JSON.stringify(item)}`);
              const skill = item.skill_id;
              console.log(`skill ${skill}`);
              if (skill) {
                return skill === res.skill;
              }
              return false;
            });
            console.log(`learnerSkillArr ${JSON.stringify(learnerSkillArr)}`);
            res.skillName = learnerSkillArr[0].skill_alias;
          } else {
            res.skillName = '';
          }
          if (res.proficiency) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const learnerProfArr = proficiency.value.filter((item: any) => {
              console.log(`item ${JSON.stringify(item)}`);
              const prof = item.prof_id;
              console.log(`prof ${prof}`);
              if (prof) {
                return prof === res.proficiency;
              }
              return false;
            });
            console.log(`learnerProfArr ${JSON.stringify(learnerProfArr)}`);
            res.proficiencyName = learnerProfArr[0].prof_name;
          } else {
            res.proficiencyName = '';
          }
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        learnerData.value = learnerData.value.sort((a: any, b: any) => b.ageing - a.ageing);
        // if (learnerData.value.length > 0) {
        //   learnerData.value.sort((a: any, b: any) => parseInt(b.ageing, 10) - parseInt(a.ageing, 10));
        // }

        renderReady.value = true;
        // }
      } catch (error) {
        console.log(error);
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedSkill = async (e: any) => {
      // console.log(e.target.removeAttr('selected'));
      selectedSkill.value = e.target.value;
      Object.assign(FilterData, { skill: selectedSkill.value });
      // await getLearnerForProxy();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedProficiency = async (e: any) => {
      selectedProficiency.value = e.target.value;
      Object.assign(FilterData, { proficiency: selectedProficiency.value });
      // await getLearnerForProxy();
    };
    const showProxy = async () => {
      console.log(`selectedTaskId.value[0] ${selectedTaskId.value[0]}`);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const selectedLearnerArr = learnerData.value.filter((learner: any) => selectedTaskId.value[0] === learner.learner_task_id);
      console.log(`selectedLearnerArr ${selectedLearnerArr}`);
      selectedLearnerSkill.value = selectedLearnerArr[0].skill;
      selectedLearnerProficiency.value = selectedLearnerArr[0].proficiency;
      isVisible.value = true;
      renderReady.value = false;
      // proxyList.value = await invokeGetProxyList('/getAllProxyBySkill', selectedSkill.value);
      proxyList.value = await invokeGetProxyList('/getAllProxyBySkill', selectedLearnerSkill.value);
      renderReady.value = true;
      console.log('Proxy List', proxyList.value);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const showAssignProxyBtn = async (event: any) => {
      const proxyOhr = event.target.checked;
      if (proxyOhr === true) {
        proxyAssignedBtn.value = true;
      } else {
        proxyAssignedBtn.value = false;
      }
    };
    const assignLearnerToProxy = async () => {
      try {
        console.log(`selectedProxyOhr.value[0] ${selectedProxyOhr.value[0]}`);
        console.log(`selectedSkill.value ${selectedLearnerSkill.value}`);
        console.log(`selectedProficiency.value ${selectedLearnerProficiency.value}`);
        renderReady.value = false;
        const data = {
          proxy_key: selectedProxyOhr.value[0],
          learners: selectedTaskId.value,
          linked_program_name: 'infinity',
          skill: selectedLearnerSkill.value,
          proficiency: selectedLearnerProficiency.value,
        };
        const assignProxyRes = await invokeAssignProxyToLearners('/proxyreview', data);
        isVisible.value = false;
        await getLearnerForProxy();
        // router.push({ path: 'assignProxy' });
        // router.go(0);
        renderReady.value = true;
        console.log('data ohr', assignProxyRes);
      } catch (error) {
        console.log('data ohr', error);
      }
    };
    const triggerProxyReport = async () => {
      const reportResponse = await invokeAssignedProxyTriggerReport('/admin/proxy/export');
      reportSuccessMessage.value = 'The report will be emailed to you';
      setTimeout(() => {
        reportSuccessMessage.value = null;
      }, 6000);
      console.log(`Report Trigger Response ${reportResponse}`);
    };
    onBeforeMount(async () => {
      await getSkillandProf();
      // await getLearnerForProxy();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      userRole.value = role.user_roles;
      if (userRole.value.length > 0) {
        if (userRole.value.includes('System Admin') || userRole.value.includes('Community Manager') || userRole.value.includes('Proxy Admin')) {
          showScreen.value = true;
        } else {
          showScreen.value = false;
        }
      }
    });
    return {
      learnerData,
      skills,
      proficiency,
      renderReady,
      getSelectedSkill,
      getSelectedProficiency,
      isVisible,
      showProxy,
      getSkillandProf,
      getLearnerForProxy,
      selectedTaskId,
      proxyButtonVisible,
      setProxyBtn,
      proxyList,
      selectedProxyOhr,
      checkOne,
      showAssignProxyBtn,
      proxyAssignedBtn,
      assignLearnerToProxy,
      showScreen,
      triggerProxyReport,
      reportSuccessMessage,
    };
  },
});
